import PaymentSelectForm from "@/components/Form/PaymentSelectForm/index";
import { jsx as _jsx } from "react/jsx-runtime";
export default function SubScriptionStep1(_ref) {
  var onSubmit = _ref.onSubmit,
      error = _ref.error,
      clearError = _ref.clearError,
      recaptchaSuccessV3 = _ref.recaptchaSuccessV3,
      recaptchaCounterV2 = _ref.recaptchaCounterV2;
  return /*#__PURE__*/_jsx(PaymentSelectForm, {
    mode: "svod",
    onSubmit: onSubmit,
    error: error,
    clearError: clearError,
    paymentText: "\u5185\u5BB9\u306E\u78BA\u8A8D\u3078",
    recaptchaSuccessV3: recaptchaSuccessV3,
    recaptchaCounterV2: recaptchaCounterV2
  });
}